import type { Callout, SubVerticalCrTopicPageQuery } from '../../../generated/frontend'
import { useBaseMetaTags } from '../../../shared/hooks/useBaseMetaTags'
import { usePageProps } from '../../../shared/usePageProps'
import { generateSchemaFromSnippet } from '../../../shared/utils/get-schema-from-snippet'
import { useSubVerticalDataLayer } from './useSubVerticalDataLayer'

export const useSubVerticalMetaTags = () => {
  const { getDataLayerItems } = useSubVerticalDataLayer()
  const { getBaseMetaTags } = useBaseMetaTags()
  const { context } = usePageProps()

  return {
    getMetaTags({ meta, callout, imageUrl }: MetaProps) {
      // TODO: come back to this - CDD-2156
      const image =
        imageUrl ||
        (callout && callout.items.length !== 0 && callout.items[0]?.image?.src) ||
        undefined

      return [
        ...generateSchemaFromSnippet(meta['headCodeBlock']),
        ...getBaseMetaTags({ meta, imageUrl: image, context }),
        ...getDataLayerItems(meta),
      ]
    },
  }
}

///////// IMPLEMENTATION /////////

export type MetaProps = {
  meta: SubVerticalCrTopicPageQuery['subVerticalPage']['meta']
  callout: Callout
  imageUrl?: string
}
